var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Watch } from 'vue-property-decorator';
// @ts-ignore
import { WordCloud } from '@antv/g2plot';
import { Getter, State } from 'vuex-class';
let Page6 = class Page6 extends Vue {
    constructor() {
        super(...arguments);
        this.plotIns = null;
        this.timer = null;
    }
    handleCurrentWatch(e) {
        const noPage5 = Object.keys(this.page5).length === 0;
        const re = noPage5 ? 5 : 6;
        e === re && this.draw();
        // e !== re && this.destoryIns()
    }
    destoryIns() {
        this.timer && clearTimeout(this.timer);
        if (this.plotIns) {
            this.plotIns = null;
            const d = document.querySelector('#word-cloud');
            d.firstChild && d.removeChild(d.firstChild);
        }
    }
    draw() {
        const d = document.querySelector('#word-cloud');
        if (d.firstChild) {
            return;
        }
        let worldLengthMax = 0;
        // let worldLengthMin = 2
        this.page6.dm_words_cloud.forEach(i => {
            if (i.length > worldLengthMax) {
                worldLengthMax = i.length;
            }
            // if (i.length && i.length < worldLengthMin) {
            //   worldLengthMin = i.length
            // }
        });
        const data = this.page6.dm_words_cloud.map(i => {
            const _l = i.length;
            // const value = _l === worldLengthMax ? 3 : _l === worldLengthMin ? 2 : 1
            const value = _l === worldLengthMax ? 3 : 1;
            return {
                name: i,
                value,
            };
        });
        const config = {
            data,
            wordField: 'name',
            weightField: 'value',
            colorField: 'name',
            color: ['#ffa6b1', '#9ed7c9', '#3e8b7d', '#ffd5be', '#aae9dd', '#ffda5c'],
            wordStyle: {
                fontFamily: 'Helvitica',
                fontWeight: 'bold',
                fontSize: [20, 24],
                padding: 1,
                rotation: 0,
            },
            tooltip: false,
            spiral: 'rectangular',
            random: () => 0.5, // 固定位置
        };
        this.timer = setTimeout(() => {
            this.plotIns = new WordCloud('word-cloud', config);
            this.plotIns.render();
        }, 500);
    }
};
__decorate([
    Getter
], Page6.prototype, "page6", void 0);
__decorate([
    Getter
], Page6.prototype, "page5", void 0);
__decorate([
    State
], Page6.prototype, "current", void 0);
__decorate([
    Watch('current')
], Page6.prototype, "handleCurrentWatch", null);
Page6 = __decorate([
    Component
], Page6);
export default Page6;
